<template> 
    <span>
        <input :disabled="(readonly && readonly==true)?'':null" type="text" :placeholder="placeholderStr" :value="selectedName" class="form-control form-select-account" :style="'width: ' + widthNum + 'px;'" readonly="readonly" @click="selectAccount();">
        <bootstrap-modal ref="selectAccountModal" :size="'medium'" class="os-host os-theme-dark os-host-resize-disabled os-host-scrollbar-horizontal-hidden os-host-scrollbar-vertical-hidden os-host-transition">
            <div slot="title">{{placeholderStr}}</div>
            <div slot="body">
                <vue-ztree ref="ztr" :treeNodes="treeNodes" @onClick="handleTreeClick" :check="check" @onCheck="handleCheck" :treeName="treeName"/>
            </div>
            <div slot="footer">
				<button type="button" class="btn btn-default" data-dismiss="modal" @click="selectEmpty();">不选择</button>
            </div>
        </bootstrap-modal>     
    </span>
</template>
<script>
    import store from '@/store';
    export default {
        data(){
            return {
                check:{
                    enable: false
                },
                treeNodes: [],
                treeName: "",
                selectedName: "",
                widthNum : 150,
                placeholderStr : "",
            }
        },
        props: {
            value : null,
            width: null,
            placeholder : null,
            readonly: null,
        },
        watch: {
            value: {
    　　　　    handler(newValue, oldValue) {
                    var that = this;
                    setTimeout(()=>{that.syncNodeNameById(this.treeNodes, newValue);that.selected(newValue);},0);                    
    　　　　    },
    　　　　    deep: true
    　　    }
        },
        mounted(){
            $(this.$refs.selectAccountModal.$el).overlayScrollbars({autoUpdate:true}); 
        },
        created(){            
            if(this.width)
                this.widthNum = this.width;
            if(this.placeholder)
                this.placeholderStr = this.placeholder;
            this.loadTreeNodesFromServer();
        },
        methods: {
            selected(nodeId){
                if(!nodeId || nodeId == '')
                    return;
                var that = this;
                var zTree = that.$refs.ztr.ztree;
                zTree.cancelSelectedNode();//先取消所有的选中状态
                //Ztree.expandAll(false);//有bug
                var nodes = zTree.getNodesByParam("fid", nodeId);
                nodes.forEach((node)=>{
                    if(node.isParent == false){                        
                        zTree.selectNode(node,true);//将指定ID的节点选中
                        zTree.expandNode(node, true, false);//将指定ID节点展开
                    }
                })
                //var node = zTree.getNodeByParam("fid", nodeId);                
            },
            syncNodeNameById(treeNodes, nodeId){                
                var that = this;
                if(!nodeId || nodeId == ''){
                    that.selectedName = '';
                    return;
                }                
                treeNodes.forEach(node => {
                     if(node.fid == nodeId && node.isParent == false){
                        that.selectedName = node.name;
                     }else if(node.children && node.children.length > 0){
                        that.syncNodeNameById(node.children, nodeId)
                     }
                });
            },
            selectAccount(){
                this.$refs.selectAccountModal.open();      
                         
            },
            selectEmpty(){
                this.selectedName = "";
                this.$refs.selectAccountModal.close();
                this.$emit("input", null);
                this.$emit("change", null);       
            },
            loadTreeNodesFromServer(){
                var that = this;
                that.$http.get(store.ctx+ "/msu/common/data/department/deptAccountNodes").then((response)=>{
                    that.treeNodes = response.data;
                    that.treeName = "account select tree";
                    setTimeout(()=>{that.syncNodeNameById(that.treeNodes, that.value);that.selected(that.value);}, 0);                    
                });
            },
            handleTreeClick(event,treeId,treeNode) {
                if(treeNode.isParent == false){
                    this.selectedName = treeNode.name;
                    this.$refs.selectAccountModal.close();
                    this.$emit("input", treeNode.fid);
                    this.$emit("change", treeNode.fid);                    
                }
            },
            handleCheck(event,treeId,treeNode) {
            }          
        }
    }
</script>
<style>
.os-host, .os-host-textarea{
    position: fixed;
} 
.form-select-account{
    background-color: #fff!important;
}
</style>



// WEBPACK FOOTER //
// src/components/common/selector/data/selectorAccountTree.vue